import { Colors } from '@estee/elc-base-theme';

export const slickSlideTheme = () => `
    background-color: transparent;
    border: none;
`;

export const sliderDotButtonTheme = () => `
    font-size: 0;
    line-height: 0;
    color: transparent;
    background: transparent;

    &::before {
        font-family: 'slick';
        font-size: 24px;
        line-height: 20px;
        content: '•';
        text-align: center;
        opacity: 0.25;
        color: ${Colors.black};
    }
`;

export const sliderDotButtonActiveTheme = () => `
    &::before {
        color: ${Colors.blackMediumEmphasis};
    }
`;

export const slickDotButtonFocusTheme = () => `
    outline: 1px dotted #212121;
    outline: 5px auto -webkit-focus-ring-color;
`;

export const slickArrowTheme = () => `
    stroke: ${Colors.black};
`;

export const slickArrowDisabledTheme = () => `
    stroke: ${Colors.primary600};
`;
